import { Typography, Stack, useTheme, useMediaQuery, Button, Box, Container } from "@mui/material";
import Instructions from "../instructions/Instructions";
import { CHATBOT_WEBSITE_NAME, chatBotTipsAndTricks } from "../../constants";
import { LoginButton } from "../../components/LoginButton";
import { isLoggedIn, appServicesToken } from "../../authConfig";
import { Link } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

function InfoPage() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.down("md"));
    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const isLoggedIn = (activeAccount || appServicesToken) != null;
    return (
        <Container>
            <Stack spacing={5} display="flex" flexDirection="row" justifyContent="space-between">
                <Box>
                    <Typography marginTop={2} marginBottom={2} variant="h1">
                        {CHATBOT_WEBSITE_NAME} Tips and Tricks
                    </Typography>
                    <Typography marginBottom={4} variant="h3">
                        Please read the tips below to get the most out of {CHATBOT_WEBSITE_NAME}.
                    </Typography>
                </Box>
                <Box marginTop={4}>
                    {isLoggedIn ? (
                        <Link to="/chat">
                            <Button variant="contained" size="large">
                                Start Chatting!
                            </Button>
                        </Link>
                    ) : (
                        <LoginButton size="large" loginButtonMessage="Start Chatting" />
                    )}
                </Box>
            </Stack>

            <Stack spacing={5} display="flex" flexDirection="column" paddingX={isMobile ? 0 : isTablet ? 4 : 10}>
                <Instructions instructions={chatBotTipsAndTricks} />
            </Stack>
        </Container>
    );
}

export default InfoPage;
